import { Card, Col, Stack } from "react-bootstrap";
import moment from "moment/min/moment-with-locales";
import LoadingIndicator from "../LoadingIndicator";
import ErrorResponse from "../ErrorResponse";
import RATooltip from "../RATooltip";

export default function BreaksCard({ data, loading, error }) {
    return (
        <Card>
            <Card.Header className="d-flex align-items-center px-2">
                <span className="offset-1 flex-grow-1">Breaks</span>
                <div className="col-1 d-flex justify-content-end">
                    <RATooltip size={20}>
                        <Stack gap={2}>
                            <span>
                                <b>Overall</b>- Average duration of breaks between songs.
                            </span>
                            <span>
                                <b>W/o Ads & News</b>- Average duration of breaks not counting time for commercials or news.
                            </span>
                            <span>
                                <b>Max break</b>- longest break without music during the timeframe (can be a total of news, commercials, and a dj break back to
                                back)
                            </span>
                        </Stack>
                    </RATooltip>
                </div>
            </Card.Header>
            <Card.Body>
                <Stack className="d-flex flex-xl-row flex-column" gap={1}>
                    {loading ? (
                        <LoadingIndicator width={85} />
                    ) : error ? (
                        <ErrorResponse errorCode={error} />
                    ) : (
                        <>
                            <Col>
                                <Stack>
                                    <span className="fw-bold fs-1 text-center">
                                        {data?.break_duration.time_frame
                                            ? moment.utc(moment.duration(data.break_duration.time_frame, "s").asMilliseconds()).format("mm:ss")
                                            : "--:--"}
                                    </span>
                                    <span className="text-center fs-4">Overall</span>
                                    <span className="text-center text-muted fst-italic fs-6">
                                        <span>AVG </span>(
                                        {data?.break_duration.average
                                            ? moment.utc(moment.duration(data.break_duration.average, "s").asMilliseconds()).format("mm:ss")
                                            : "--:--"}
                                        )
                                    </span>
                                </Stack>
                            </Col>
                            <div className="vr d-none d-xl-block"></div>
                            <hr />
                            <Col>
                                <Stack>
                                    <span className="fw-bold fs-1 text-center">
                                        {data?.no_ad_break_duration.time_frame
                                            ? moment.utc(moment.duration(data.no_ad_break_duration.time_frame, "s").asMilliseconds()).format("mm:ss")
                                            : "--:--"}
                                    </span>
                                    <span className="text-center fs-4">W/o Ads & News</span>
                                    <span className="text-center text-muted fst-italic fs-6">
                                        <span>AVG </span>(
                                        {data?.no_ad_break_duration.average
                                            ? moment.utc(moment.duration(data.no_ad_break_duration.average, "s").asMilliseconds()).format("mm:ss")
                                            : "--:--"}
                                        )
                                    </span>
                                </Stack>
                            </Col>
                            <div className="vr d-none d-xl-block"></div>
                            <hr />
                            <Col>
                                <Stack>
                                    <span className="fw-bold fs-1 text-center">
                                        {data?.max_break_duration.time_frame
                                            ? moment.utc(moment.duration(data.max_break_duration.time_frame, "s").asMilliseconds()).format("mm:ss")
                                            : "--:--"}{" "}
                                    </span>
                                    <span className="text-center fs-4">Max break</span>
                                    <span className="text-center text-muted fst-italic fs-6">
                                        <span>Peak </span>(
                                        {data?.max_break_duration.average
                                            ? moment.utc(moment.duration(data.max_break_duration.average, "s").asMilliseconds()).format("mm:ss")
                                            : "--:--"}
                                        )
                                    </span>
                                </Stack>
                            </Col>
                        </>
                    )}
                </Stack>
            </Card.Body>
        </Card>
    );
}
